import React from "react";
import { Button } from "@/components/ui/button";
import { Copy, Diff, Trash2 } from "lucide-react";

interface DialogActionsProps {
  showDeleteButton: boolean;
  isAdmin: boolean;
  initialOffer: any;
  onCopyJson: () => void;
  onShowDiff: () => void;
  onDelete: () => void;
  isLoading: boolean;
  isDeleting: boolean;
}

export const DialogActions: React.FC<DialogActionsProps> = ({
  showDeleteButton,
  isAdmin,
  initialOffer,
  onCopyJson,
  onShowDiff,
  onDelete,
  isLoading,
  isDeleting
}) => {
  // Debug logging to understand why buttons might not show

  return (
    <div className="flex items-center justify-between w-full">
      {/* Delete button - positioned on the left */}
      <div>
        {showDeleteButton && (
          <Button 
            variant="outline" 
            type="button" 
            onClick={onDelete} 
            className="text-destructive border-destructive hover:bg-destructive hover:text-destructive-foreground"
            disabled={isDeleting}
          >
            <Trash2 className="mr-2 h-4 w-4" />
            Delete
          </Button>
        )}
      </div>

      {/* Admin-only buttons - positioned on the right */}
      <div className="flex items-center gap-2">
        {isAdmin && (
          <>
            <Button 
              variant="outline" 
              type="button" 
              onClick={onShowDiff} 
              disabled={isLoading}
              className="text-blue-600 border-blue-200 hover:bg-blue-50"
            >
              <Diff className="mr-2 h-4 w-4" />
              {initialOffer ? "See diff before save" : "Preview changes"}
            </Button>
            
            <Button 
              variant="outline" 
              type="button" 
              onClick={onCopyJson}
              className="text-green-600 border-green-200 hover:bg-green-50"
            >
              <Copy className="mr-2 h-4 w-4" />
              {initialOffer ? "Get Full JSON" : "Get Form JSON"}
            </Button>
          </>
        )}
      </div>

    </div>
  );
};
